import Model from '@/lib/data/Model';
import FileStorageItem from '../FileStorageItem';

class CollectionInfo extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'policy_id',
        'total_collected',
        'total_pending',
        'total_collected_cur',
        'total_pending_cur',
        'note',
        {
            name: 'files',
            association: {
                type: 'many',
                model: FileStorageItem,
                collectionConfig: {
                    url: '/policy/collection/files/list',
                },
            },
        },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'saveOrUpdate',
            url: '/policy/collectioninfo/saveorupdate',
            associated: true,
        },
        {
            name: 'saveOrUpdateShare',
            url: '/policy/collectioninfo/saveorupdateshare',
            associated: true,
        },
        {
            name: 'read',
            url: '/policy/collectioninfo/get',
            params: ['policy_id'],
        },
    ];
}

export default CollectionInfo;
